import React, { useState, useEffect } from "react";
import cx from "classnames";
import s from "./qbmoveStatus.scss";
import QboxmailApi from "@/qboxmailApi";
import { useHistory, useLocation } from "react-router-dom";
import { Icon, refresh, close } from "Icons/index";
import Modal from "Components/smallModal/smallModal";
import ResponsiveTable from "Components/responsiveTable/ResponsiveTable";
import Button from "Components/button/Button";
import { t } from "i18next";
import _ from "lodash";
import PaginationShow from "Components/paginationShow/PaginationShow";
import PaginationFilter from "Components/paginationFilter/PaginationFilter";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import ListFilter from "Components/listFilter/ListFilter";
import Pager from "Components/pager/Pager";
import MigrationLogModal from "Components/MigrationLogModal";
import DomainStatusBadge from "Components/domainStatusBadge/DomainStatusBadge";
import CopyToClipboard from "react-copy-to-clipboard";
import qs from "query-string";

const api = new QboxmailApi({ useCookie: true });

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => Object.fromEntries(new URLSearchParams(search)), [search]);
}

const OperationType = ({ type, meta_type, code }) => {
  return (
    <div>
      {type === "vault_import" ? `Import Archivio` : type === "migration" ? "Migrazione" : ""}
      {meta_type === "test" && <span> (test)</span>}
      {meta_type === "first_execution" && <span> (1° esecuzione)</span>}
      {meta_type === "second_execution" && <span> (2° esecuzione)</span>}
      <span className={s.operationTypeCode}>#{code}</span>
    </div>
  );
};

export default function QbMoveStatus() {
  const history = useHistory();
  const location = useLocation();
  let query = useQuery();

  const [lastRefresh, setLastRefresh] = useState(new Date());
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [copiedLog, setCopiedLog] = useState(false);
  const [copiedCommand, setCopiedCommand] = useState(false);

  const [selectedRun, setSelectedRun] = useState(null);

  // log details
  const [modalLogOpened, setModalLogOpened] = useState(false);
  const [logContent, setLogContent] = useState(null);
  const [isLogLoading, setIsLogLoading] = useState(false);
  const [isLogErrored, setIsLogErrored] = useState(false);

  useEffect(() => {
    fetchStatus(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchStatus(query);
  }, [query]);

  const refreshStatus = async () => {
    await fetchStatus(query, true);
  };

  const fetchStatus = async (query, refreshing) => {
    if (refreshing) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }

    const response = await api.getMigrationStatus(query);
    setStatus(response);
    setLastRefresh(new Date());
    setRefreshing(false);
    setLoading(false);
  };

  const showRunDetail = (run) => {
    setSelectedRun(run);
  };

  const resetStateAndClose = () => {
    setSelectedRun(null);
    setCopiedLog(false);
    setCopiedCommand(false);
  };

  const showImapsyncCommand = (command) => {
    const styles = "max-width: 100%; overflow-x: auto; line-height: 150%; height: 100%;white-space: pre-wrap;";
    window.open().document.write(`<pre style="${styles}">${command}</pre>`);
  };

  const showLog = async (run) => {
    setIsLogLoading(true);
    setModalLogOpened(true);
    const log = await api.getQbmoveLog(run.code);
    setIsLogLoading(false);
    if (!log.log_content) {
      setIsLogErrored(true);
      return;
    }
    setLogContent(log.log_content);
  };

  const resetLogModal = () => {
    setModalLogOpened(false);
    setLogContent(null);
    setIsLogLoading(false);
    setIsLogErrored(false);
  };

  return (
    <div className={s.page}>
      <div className={s.header}>
        <div className={cx("sectionTitle")}>Qbmove Stato Server</div>
        <div className={s.lastUpdate}>Ultimo aggiornamento: {lastRefresh.toLocaleString()}</div>
      </div>

      <Modal title={"Dettagli"} opened={!!selectedRun} closeModal={resetStateAndClose} largeModal>
        {selectedRun && (
          <div className={s.runList}>
            <div className={s.runCard}>
              <div className={s.runHeader}>
                <OperationType
                  type={selectedRun.operation_type}
                  meta_type={selectedRun.operation_meta_type}
                  code={selectedRun.operation_code}
                />
              </div>

              <div className={s.runDetail}>
                <div className="">
                  <div>{selectedRun.user_2}</div>
                  <div className={s.runCardHost}>{selectedRun.host_2}</div>
                </div>
                <span className={s.accentArrow}>←</span>
                <div className="">
                  <div>{selectedRun.user_1}</div>
                  <div className={s.runCardHost}>{selectedRun.host_1}</div>
                </div>
              </div>

              <div className={s.runCardSection}>
                <div className="text-[--text-a40]">Codice</div>
                <div className={s.runValue}>{selectedRun.code}</div>
              </div>

              {selectedRun.status === "running" ? (
                <>
                  <div className={s.runCardSection}>
                    <div className="text-[--text-a40]">Avviata il </div>
                    <div className={s.runValue}>{new Date(selectedRun.started_at).toLocaleString()}</div>
                  </div>
                  <div className={s.runCardSection}>
                    <div className="text-[--text-a40]">Progresso</div>
                    <div className={s.runValue}>
                      {selectedRun.progress_percentage ? `${selectedRun.progress_percentage}%` : "0%"}
                    </div>
                  </div>

                  <div className={s.runCardSection}>
                    <div className="text-[--text-a40]">Percorso log</div>
                    <div className="text-right">{selectedRun.log}</div>
                  </div>
                </>
              ) : (
                <>
                  <div className={s.runCardSection}>
                    <div className="text-[--text-a40]">Programmata per </div>
                    <div className={s.runValue}>{new Date(selectedRun.scheduled_at).toLocaleString()}</div>
                  </div>
                  <div className={s.runCardSection}>
                    <div className="text-[--text-a40]">Terminata il </div>
                    <div className={s.runValue}>
                      {new Date(selectedRun.ended_at || selectedRun.updated_at).toLocaleString()}
                    </div>
                  </div>

                  <div className={cx(s.runCardSection, s.runCardSectionVertical)}>
                    <div className="text-[--text-a40] mb-1">Percorso Log</div>
                    <div className="">
                      <div className={s.wrapCopyToClipboard}>
                        <CopyToClipboard text={selectedRun.log} onCopy={() => setCopiedLog(true)}>
                          <div
                            title="click to copy"
                            className="mb-2 cursor-pointer font-mono text-xs break-all bg-[--bg]"
                          >
                            {selectedRun.log}
                          </div>
                        </CopyToClipboard>
                        {copiedLog && <div className="text-sm text-[--green]">Copied!</div>}
                      </div>

                      {selectedRun.status !== "crashed" && selectedRun.status !== "scheduled" && (
                        <a onClick={() => showLog(selectedRun)}>Mostra contenuto</a>
                      )}
                    </div>
                  </div>
                </>
              )}

              {selectedRun.status === "crashed" && (
                <div className={cx(s.runCardSection, s.runCardSectionVertical)}>
                  <div className="text-[--text-a40]">L'esecuzione è stata interrotta con i seguenti errori</div>
                  Il processo imapsync è stato interrotto. Impossibile avere maggiori dettagli.
                </div>
              )}

              {selectedRun.status === "error" && (
                <div className={cx(s.runCardSection, s.runCardSectionVertical)}>
                  <div className="text-[--text-a40]">L'esecuzione è stata interrotta con i seguenti errori</div>

                  <ul className={s.errorsList}>
                    {selectedRun.errors.code === "unhandled_error" ? (
                      <div className="px-2 text-red-500 rounded-md bg-red-50">Impossibile parsare errore</div>
                    ) : (
                      selectedRun.errors.errors.map((error, index) => (
                        <li className={s.runValue} key={index}>
                          <pre
                            dangerouslySetInnerHTML={{ __html: t(`qbmove.error.${error.code}`, null, error.detail) }}
                          ></pre>
                        </li>
                      ))
                    )}
                  </ul>
                </div>
              )}

              <div className={cx(s.runCardSection, s.runCardSectionVertical)}>
                <div className="text-[--text-a40] mb-1">Comando Imapsync</div>
                <div className="">
                  <div className={s.wrapCopyToClipboard}>
                    <CopyToClipboard text={selectedRun.command} onCopy={() => setCopiedCommand(true)}>
                      <div title="click to copy" className="mb-2 cursor-pointer font-mono text-xs break-all bg-[--bg]">
                        {selectedRun.command}
                      </div>
                    </CopyToClipboard>
                    {copiedCommand && <div className="text-sm text-[--green]">Copied!</div>}
                  </div>

                  <a onClick={() => showImapsyncCommand(selectedRun.command)}>Mostra comando imapsync</a>
                </div>
              </div>
            </div>
          </div>
        )}

        <div>
          <Button type="button" color="text" onClick={resetStateAndClose}>
            button.close
          </Button>
        </div>
      </Modal>

      <MigrationLogModal
        opened={modalLogOpened}
        handleClose={resetLogModal}
        log={logContent}
        isLogLoading={isLogLoading}
        isLogErrored={isLogErrored}
      />

      {/* <AutoRefresher refreshTime={10000} refreshFn={refreshStatus} needRefresh={true} /> */}

      <div className={s.topArea}>
        <ResponsiveTable
          className={s.serversTable}
          verticalOnMobile
          history={history}
          areRowsLoading={loading && !status}
          location={location}
          headers={[{ name: "id" }, { name: "caratteristiche" }, { name: "processi", right: true }]}
          rows={(status ? status.servers : []).map((server) => {
            return (
              <tr
                key={server.id}
                className={cx({
                  ["pointer-events-none bg-red-50"]: server.disabled,
                })}
              >
                <td>{server.id}</td>
                <td>
                  {server.disabled ? (
                    <div className="font-medium text-red-500">
                      {server.integrity_error
                        ? `Errore: ${t(`qbmove.error.${server.integrity_error}`)}`
                        : "Disattivato da admin"}
                    </div>
                  ) : (
                    ""
                  )}

                  <pre className="pt-1 text-xs font-semibold">{server.host}</pre>

                  <ul className="py-1 text-xs opacity-50">
                    {server.operation_meta_type && (
                      <li>
                        <span>Solo operazioni:</span> {server.operation_meta_type}
                      </li>
                    )}

                    {server.customers && server.customers.length > 0 && (
                      <li>
                        <span>Solo clienti:</span> {server.customers.join(", ")}
                      </li>
                    )}

                    <li>
                      <span>Max in parallelo per cliente :</span> {server.max_parallel_per_customer || "nessun limite"}
                    </li>
                  </ul>
                </td>
                <td className="text-right">
                  <a
                    onClick={() => {
                      history.push({ search: qs.stringify({ server_id: server.id }) });
                    }}
                  >
                    {server.running ? server.running.length : 0} / {server.max}
                  </a>
                </td>
              </tr>
            );
          })}
        ></ResponsiveTable>

        <ResponsiveTable
          className={s.overviewTable}
          verticalOnMobile
          areRowsLoading={loading && !status}
          headers={[{ name: "coda" }, { name: "processi", right: true }]}
          rows={[
            { label: "Operazioni in coda", value: status ? status.late : "-", key: "late" },
            { label: "Operazioni programmate", value: status ? status.scheduled : "-", key: "scheduled" },
          ].map((o) => {
            return (
              <tr key={o.label}>
                <td>{o.label}</td>
                <td style={{ textAlign: "right" }}>
                  <a
                    onClick={() => {
                      history.push({ search: qs.stringify({ status: o.key }) });
                    }}
                  >
                    {o.value}
                  </a>
                </td>
              </tr>
            );
          })}
        ></ResponsiveTable>
      </div>

      <div className="flex items-center justify-between w-full mb-4">
        <div className="flex items-center flex-grow gap-4">
          <ListFilter
            className={s.statusFilter}
            labelPrefix="qbmove"
            values={["all", "success", "running", "scheduled", "error", "crashed"]}
            active={query.status}
            location={location}
            paginationInfo={status ? status.pagination : {}}
            url={location.pathname}
          />

          <ListFilter
            className={s.statusFilter}
            labelPrefix="qbmove.types"
            values={["all", "migration", "vault_import"]}
            active={query.operation_type}
            location={location}
            param="operation_type"
            paginationInfo={status ? status.pagination : {}}
            url={location.pathname}
          />

          <PaginationFilter
            className="max-w-[320px]"
            url={location.pathname}
            currentQuery={query.query}
            paginationFilter={query}
            placeholder="Cerca per codice customer, migrazione, ecc..."
          />

          {query.server_id && (
            <div className={s.activeFilter}>
              Mostra solo server ID: {query.server_id}
              <Icon
                className={s.activeFilterClose}
                svg={close}
                onClick={() => history.push({ search: qs.stringify({}) })}
                width="13px"
                height="13px"
                color="var(--accent)"
              />
            </div>
          )}
        </div>

        <div className={s.filtersBlock}>
          <ButtonIcon
            className={cx(s.iconRefresh, { ["isRefreshing"]: refreshing })}
            icon={refresh}
            onClick={refreshStatus}
          />
          <PaginationShow
            className={s.pageShow}
            options={[
              { value: 25, label: 25 },
              { value: 50, label: 50 },
              { value: 100, label: 100 },
            ]}
            history={history}
            location={location}
          />
          <Pager
            className={s.pagination}
            history={history}
            paginationInfo={{
              ...query,
              ...(status
                ? {
                    page: status.runs.pagination.currentPage,
                    total_pages: status.runs.pagination.lastPage,
                    per: status.runs.pagination.perPage,
                  }
                : {}),
            }}
            url={location.pathname}
          />
        </div>
      </div>

      <ResponsiveTable
        verticalOnMobile
        history={history}
        areRowsLoading={loading}
        location={location}
        headers={[
          { name: t("table.header.status") },
          { name: "Operazione" },
          { name: t("table.header.account") },
          {
            name: "Progresso",
            key: "progress_percentage",
            sortable: true,
            activeSorting: query.sort_field === "progress_percentage" && query.sort,
          },
          {
            name: "Programmata per",
            key: "scheduled_at",
            sortable: true,
            activeSorting: query.sort_field === "scheduled_at" && query.sort,
          },
          {
            name: "Server ID",
          },
          {
            name: "-",
          },
        ]}
        rows={_.map(status ? status.runs.data : [], (run) => {
          return (
            <tr key={run.code}>
              <td data-label="" className="flex pl-1">
                <DomainStatusBadge status={run.status} qbmove />
              </td>
              <td>
                <OperationType
                  type={run.operation_type}
                  meta_type={run.operation_meta_type}
                  code={run.operation_code}
                />
              </td>

              <td data-label={t("table.header.account")}>
                {run.user_2} <span className={s.accentArrow}>←</span> {run.user_1}{" "}
                <span className={s.host}> - {run.host_1}</span>{" "}
              </td>

              {run.status === "running" ? <td>{run.progress_percentage || 0} %</td> : <td>-</td>}

              <td>{run.scheduled_at ? new Date(run.scheduled_at).toLocaleString() : "-"}</td>
              <td>{run.server_id}</td>
              <td>
                <a onClick={() => showRunDetail(run)}>Dettagli</a>
              </td>
            </tr>
          );
        })}
      />
    </div>
  );
}
